import {
  DebitCardTransaction,
  PlaidTransaction,
  RdcTransaction,
  Transaction,
  V2ATransaction,
  V2VTransaction,
} from '@varo/graphql-schema-types';
import { useCallback } from 'react';
import TransactionR2 from 'services/graphql/queries/TransactionR2';
import { useQuery } from 'urql';

export interface ITransactionTypes {
  transactionR2:
    | DebitCardTransaction
    | PlaidTransaction
    | RdcTransaction
    | Transaction
    | V2ATransaction
    | V2VTransaction;
}

const useGetTransactionDetails = (transactionId: string | string[]) => {
  const [{ data, fetching, error }, refetch] = useQuery<ITransactionTypes>({
    query: TransactionR2,
    variables: {
      id: transactionId,
    },
    requestPolicy: 'network-only',
  });

  const reload = useCallback((): void => {
    refetch({
      requestPolicy: 'network-only',
    });
  }, [refetch]);

  return {
    transactionR2: data?.transactionR2,
    error,
    loading: fetching,
    reload,
  };
};

export default useGetTransactionDetails;
